import React from 'react';

const ModelCard = ({ product, isDarkMode, onClick }) => {
  if (!product) {
    console.warn('Product object is undefined');
    return null;
  }

  // Calculate base price from deductions
  const getBasePrice = () => {
    if (!product.deductions) return null;
    
    // Find overall price deduction (is_over_all_price = true)
    const overallPrice = product.deductions.find(d => d.is_over_all_price === true);
    if (overallPrice) {
      return overallPrice.value;
    }
    return null;
  };

  const basePrice = getBasePrice();
  // ProductResource.title is the canonical display name (brand included once).
  const displayName = String(product.title || product.name || '').trim() || 'Unknown Product';

  return (
    <div
      onClick={onClick}
      className={`group relative rounded-lg overflow-hidden cursor-pointer transition-all duration-200 flex flex-col ${
        isDarkMode 
          ? 'bg-gray-800 hover:bg-gray-700' 
          : 'bg-white shadow-[0_2px_6px_rgba(0,0,0,0.06)] hover:shadow-[0_4px_10px_rgba(0,180,120,0.15)] border border-transparent hover:border-emerald-200'
      }`}
    >
      {/* Product Image */}
      <div className="pt-3 pb-0.5 px-2">
        <div className="flex items-center justify-center w-full aspect-square">
          <img
            src={product.image}
            alt={displayName}
            className="object-contain w-2/3 h-2/3"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder-product.png';
            }}
          />
        </div>
      </div>

      {/* Product Name - Full text, no truncation, with word wrapping */}
      <div className="flex-grow px-1 pb-2 text-center">
        <h3 className={`text-[11px] font-medium leading-tight break-words ${
          isDarkMode ? 'text-gray-200 group-hover:text-gray-100' : 'text-gray-700 group-hover:text-emerald-700'
        }`}>
          {displayName}
        </h3>
        {basePrice && (
          <p className={`text-[9px] mt-0.5 font-medium ${
            isDarkMode ? 'text-gray-400' : 'text-emerald-600'
          }`}>
            Up to ₹{parseInt(basePrice).toLocaleString()}
          </p>
        )}
      </div>

      {/* Green Accent Line - Fixed at bottom */}
      {!isDarkMode && (
        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-bottom" />
      )}
    </div>
  );
};

export default ModelCard;